import { ComponentType, PropsWithChildren } from "react";

import { RouteProps } from "@/contexts/RouteContext";
import { RouteProvider } from "@/providers/RouteProvider";
import { EmptyObject } from "@/types/EmptyObject";

// ページコンポーネントが受け取るPropsの型定義
// (RouteProps と pageName が自動で付与されます)
export type PageComponentProps<P = EmptyObject> = P &
  RouteProps & {
    pageName: string;
  };

/**
 * ページコンポーネントを作成するファクトリー関数
 * @param pageName - ページの名前 (一意のID)
 * @param PageComponent - 実装するコンポーネント
 */
export function createPage<P extends object>(pageName: string, PageComponent: ComponentType<PageComponentProps<P>>) {
  const WrappedComponent = (props: PropsWithChildren<P & RouteProps>) => {
    return (
      <RouteProvider
        f7route={props.f7route}
        f7router={props.f7router}
      >
        <PageComponent
          {...(props as P & RouteProps)}
          pageName={pageName}
        />
      </RouteProvider>
    );
  };

  WrappedComponent.displayName = `Page(${pageName})`;

  return WrappedComponent;
}
